(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = () => {
    document.querySelectorAll('[data-md-slider]').forEach(slider => {
      if (slider.dataset.ready) return;
      slider.dataset.ready = 'true';
      const section = slider.closest('.md-discover');
      const prev = section.querySelector('[data-md-prev]');
      const next = section.querySelector('[data-md-next]');
      const step = () => (slider.firstElementChild?.getBoundingClientRect().width || slider.clientWidth) + 18;
      const move = direction => slider.scrollBy({left: direction * step(), behavior: reducedMotion.matches ? 'instant' : 'smooth'});
      const sync = () => {
        if (prev) prev.disabled = slider.scrollLeft < 4;
        if (next) next.disabled = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 4;
      };
      prev?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      slider.addEventListener('scroll', sync, {passive: true});
      slider.addEventListener('keydown', event => {
        if (event.target !== slider) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      let startX = 0;
      let startScroll = 0;
      let pointer = null;
      let dragged = false;
      slider.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        pointer = event.pointerId;
        startX = event.clientX;
        startScroll = slider.scrollLeft;
        dragged = false;
      });
      slider.addEventListener('pointermove', event => {
        if (pointer !== event.pointerId) return;
        if (Math.abs(event.clientX - startX) > 7) {
          dragged = true;
          slider.dataset.dragging = 'true';
          slider.setPointerCapture(event.pointerId);
          slider.scrollLeft = startScroll - (event.clientX - startX);
        }
      });
      const finish = event => {
        if (pointer !== event.pointerId) return;
        if (slider.hasPointerCapture(event.pointerId)) slider.releasePointerCapture(event.pointerId);
        pointer = null;
        delete slider.dataset.dragging;
        sync();
      };
      slider.addEventListener('pointerup', finish);
      slider.addEventListener('pointercancel', finish);
      slider.addEventListener('dragstart', event => event.preventDefault());
      slider.addEventListener('click', event => {
        if (dragged) {
          event.preventDefault();
          event.stopPropagation();
          dragged = false;
        }
      }, true);
      new ResizeObserver(sync).observe(slider);
      sync();
    });
    document.querySelectorAll('.md-new-menu').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          menu.open = false;
          menu.querySelector('summary').focus();
        }
      });
      menu.querySelector('nav')?.addEventListener('click', event => {
        if (event.target.closest('a')) menu.open = false;
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
